<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="REQUISIÇÃO DE COMPRA" fa-icon="dolly"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/rcms']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="entidade.id " data-toggle="modal" (click)="visualizarExclusao=true"
            class="btn btn-sm btn-outline-danger float-right mr-2">
            <img src="assets/img/global/bin_closed.png" alt="Exclusão" title="Excluir RCMS" height="22" width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar</button>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="row">
        <div class="col-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                aria-selected="true" (click)="selecionarTab(1)">Dados Requisição</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                aria-selected="false" (click)="selecionarTab(2)">Itens</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="favorecido-tab" data-toggle="tab" href="#favorecido" role="tab"
                aria-controls="favorecido" aria-selected="false" (click)="selecionarTab(3)">Fornecedores</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="cotacao-tab" data-toggle="tab" href="#cotacao" role="tab" aria-controls="cotacao"
                aria-selected="false" (click)="selecionarTab(4)">Cotações</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <br />
              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-row mt-1">
                        <div class="col-md-4">
                          <br>
                          <table>
                            <td style="font-size: 22px; font-weight: bold; color: #157111; padding-right: 4px;">Nº:</td>
                            <td style="font-size: 22px; font-weight: bold; color: #157111">{{ ("00000" +
                              (entidadeForm.get('numero').value ? entidadeForm.get('numero').value : '')).slice(-5) }}
                            </td>
                          </table>
                        </div>
                      </div>
                      <div class="form-row mt-2">
                        <div class="col-md-4" formGroupName="contrato">
                          <label for="contrato">Contrato</label>
                          <input id="contrato" formControlName="numero" type="text" unmask="true"
                            [imask]="{mask: [ {mask: '0000/0000'}, {mask: '00000/0000'} ]}"
                            class="form-control font-weight-bold" (blur)="buscarContrato()">
                        </div>
                        <div class="col-md-4">
                          <label for="processo">Processo</label>
                          <input id="processo" formControlName="processo" type="text" [unmask]="false"
                            [imask]="{mask: '0000/0000'}" class="form-control">
                        </div>
                        <div class="col-md-4" formGroupName="licitacao">
                          <label for="licitacao">Licitação</label>
                          <input formControlName="numero" type="text" class="form-control" id="licitacao"
                            [imask]="{mask: '00000/0000'}" unmask="true" (blur)="carregarLicitacao()">
                        </div>
                      </div>
                      <div class="form-row mt-3">
                        <div class="col-md-4">
                          <label for="data_rcms">Data Requisição<span class="text-danger">*</span></label>
                          <p-calendar id="data_rcms" formControlName="data_rcms"
                            (onBlur)="fichaAutoComplete.atualizar(false)" inputStyleClass="form-control" dataType="date"
                            dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                            [showButtonBar]="true" [style]="{ width: '100%' }">
                          </p-calendar>
                        </div>
                        <div class="col-sm-8">
                          <label for="requerente">Requerente<span class="text-danger">*</span></label>
                          <p-autoComplete formControlName="requerente" [field]="pessoaAutoComplete.conversor"
                            [suggestions]="pessoaAutoComplete.lista"
                            (completeMethod)="pessoaAutoComplete.filtrar($event)" placeholder="Informe o Requerente"
                            inputStyleClass="form-control autocomplete-radius-right" minLength="2"
                            [style]="{ width: 'calc(100% - 46px)', float: 'left' }" [forceSelection]="true"
                            [autoHighlight]="true" *ngIf="pessoaAutoComplete">
                            <ng-template let-pessoa pTemplate="item">
                              {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}}
                            </ng-template>
                          </p-autoComplete>
                          <button class="btn btn-outline-secondary float-right" type="button" data-toggle="modal"
                            data-target="#dialogPessoa"
                            style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
                            <em class="fa fa-user-plus"></em>
                          </button>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-sm-5">
                          <label for="prioridade">Prioridade</label>
                          <select [compareWith]="compareFn" id="prioridade" formControlName="prioridade"
                            class="form-control" style="width: 100%;">
                            <option [ngValue]="null">---</option>
                            <option [ngValue]="item" *ngFor="let item of listaPrioridade">
                              {{globalService.tituloPrioridadeRCMS(item)}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-row">
                        <div class="col-sm-12">
                          <div class="card">
                            <ul class="list-group list-group-flush">
                              <li
                                class="list-group-item font-weight-bold bg-success d-flex justify-content-between align-items-center text-white">
                                <span>Saldo</span>
                                <em class="fa fa-eye float-right" *ngIf="this.entidadeForm.get('ficha').value"
                                  (click)="visualizarFicha=true" style="cursor: pointer;"></em>
                              </li>
                              <li class="list-group-item">Dotação <span class="float-right">{{saldoFixa?.dotacao |
                                  number:'1.2-2'}}</span>
                              </li>
                              <li class="list-group-item">Reservado <span class="float-right">{{saldoFixa?.reservado |
                                  number:'1.2-2'}}</span></li>
                              <li class="list-group-item font-weight-bold text-white bg-info">
                                Total Requisição <span class="float-right font-weight-bold">{{totalRCSM() |
                                  number:'1.2-2'}}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-row">
                <div class="form-group col-sm-7">
                  <label for="setor">Setor<span class="text-danger">*</span></label>
                  <p-autoComplete #setor id="gps" formControlName="setor" [forceSelection]="true" [autoHighlight]="true"
                    [field]="setorAutoComplete.conversor" [suggestions]="setorAutoComplete.lista" [dropdown]="true"
                    (completeMethod)="setorAutoComplete.filtrar($event)" inputStyleClass="form-control" minLength="2"
                    [style]="{ width: '100%' }" (onFocus)="setor.handleDropdownClick($event)">
                    <ng-template let-setor pTemplate="item">
                      <strong>{{setor.sigla}}</strong> - {{setor.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="col-sm-5 form-group">
                  <label for="modalidade">Modalidade <span class="text-danger">*</span></label>
                  <p-autoComplete #modalidade id="gps" formControlName="modalidade" [forceSelection]="true"
                    [autoHighlight]="true" [field]="modalidadeAutoComplete.conversor"
                    [suggestions]="modalidadeAutoComplete.lista" [dropdown]="true"
                    (completeMethod)="modalidadeAutoComplete.filtrar($event)" inputStyleClass="form-control"
                    minLength="2" [style]="{ width: '100%' }" (onFocus)="modalidade.handleDropdownClick($event)">
                    <ng-template let-modalidade pTemplate="item">
                      <strong>{{modalidade.codigo}}</strong> - {{modalidade.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-3 form-group">
                  <label for="data_entrega">Data Entrega<span class="text-danger">*</span></label>
                  <p-calendar id="data_entrega" formControlName="data_entrega" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                    [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
                <div class="col-md-3 form-group">
                  <label for="data_pagamento">Data Pagamento<span class="text-danger">*</span></label>
                  <p-calendar id="data_pagamento" formControlName="data_pagamento" inputStyleClass="form-control"
                    dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                    [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>
                <div class="col-md-6 form-group">
                  <label for="prazo">Prazo<span class="text-danger">*</span></label>
                  <p-autoComplete #prazo id="prazo" formControlName="prazo" [forceSelection]="true"
                    [autoHighlight]="true" [field]="prazoAutComplete.conversor" [suggestions]="prazoAutComplete.lista"
                    [dropdown]="true" (completeMethod)="prazoAutComplete.filtrar($event)" inputStyleClass="form-control"
                    minLength="2" [style]="{ width: '100%' }" (onFocus)="prazo.handleDropdownClick($event)">
                    <ng-template let-prazo pTemplate="item">
                      {{prazo.nome}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
              <hr class="mt-3 mb-2" />
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-row">
                    <div class="form-group col-sm-12">
                      <label for="ficha" style="display: block">Ficha de despesa<span
                          class="text-danger">*</span></label>
                      <div class="col-sm-2 p-0 float-left">
                        <input class="form-control" type="text" (blur)="fichaAutoComplete.atualizar(false)"
                          [(ngModel)]="fichaAutoComplete.id" name="ficha_id" [ngModelOptions]="{standalone: true}"
                          *ngIf="fichaAutoComplete" placeholder="Código" />
                      </div>
                      <div class="col-sm-10 p-0 float-left">
                        <p-autoComplete formControlName="ficha" [field]="fichaAutoComplete.conversor"
                          [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
                          placeholder="Informe a descrição do elemento da despesa" inputStyleClass="form-control"
                          minLength="2" [style]="{ width: '100%' }" (onSelect)="fichaAutoComplete.atualizar(true)"
                          (onBlur)="fichaAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                          *ngIf="fichaAutoComplete">
                          <ng-template let-ficha pTemplate="item">
                            {{ ficha.numero }} - {{ficha.despesa.nome}}
                          </ng-template>
                        </p-autoComplete>
                      </div>

                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-sm-12">
                      <label for="subelemento" style="display: block">Subelemento da despesa<span
                          class="text-danger">*</span></label>
                      <div class="col-sm-2 p-0 float-left">
                        <input class="form-control" type="text" (blur)="subElementoAutoComplete.atualizar(false)"
                          onfocus="let value = this.value; this.value = null; this.value=value"
                          [(ngModel)]="subElementoAutoComplete.id" name="subElemento_id"
                          [ngModelOptions]="{standalone: true}" unmask="unmask" [imask]="{mask: '0.0.00.00.00.000'}"
                          *ngIf="subElementoAutoComplete" placeholder="Código" />
                      </div>
                      <div class="form-group col-sm-10 p-0 float-left">
                        <p-autoComplete formControlName="subelemento" [field]="subElementoAutoComplete.conversor"
                          [suggestions]="subElementoAutoComplete.lista"
                          (completeMethod)="subElementoAutoComplete.filtrar($event)" (onBlur)="subElementoAutoComplete.atualizar(true)"
                          placeholder="Informe a descrição do subelemento" inputStyleClass="form-control" minLength="2"
                          [style]="{ width: '100%' }" (onSelect)="subElementoAutoComplete.atualizar(true)"
                          [forceSelection]="true" [autoHighlight]="true" *ngIf="subElementoAutoComplete">
                          <ng-template let-subElemento pTemplate="item">
                            {{subElemento.codigo}} - {{subElemento.nome}}
                          </ng-template>
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-row">
                <div class="form-group col-sm-6">
                  <label for="justificativa">Justificativa</label>
                  <textarea formControlName="justificativa" class="form-control" id="justificativa" rows="3"></textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="obs">Observação</label>
                  <textarea formControlName="observacao" class="form-control" id="obs" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <app-rcms-item [rcms]="entidadeForm.value" [(lista)]="itens" [usarAtalho]="tabSelecionado(2)"
                [(login)]="login"></app-rcms-item>
            </div>
            <div class="tab-pane fade" id="favorecido" role="tabpanel" aria-labelledby="favorecido-tab">
              <app-rcms-favorecido [rcms]="entidadeForm.value" [itens]="itens" [usarAtalho]="tabSelecionado(3)"
                [(lista)]="favorecidos" [(login)]="login"></app-rcms-favorecido>
            </div>
            <div class="tab-pane fade" id="cotacao" role="tabpanel" aria-labelledby="cotacao-tab">
              <app-rcms-cotacao [(itens)]="itens" [favorecidos]="favorecidos" [(login)]="login"></app-rcms-cotacao>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<lib-pessoa-cadastro-dlg (callback)="carregarPessoa($event)" [entity]="entidadeForm.get('requerente').value"
  [login]="login"></lib-pessoa-cadastro-dlg>
<app-saldo-ficha-dlg [ficha]="this.entidade.ficha ? this.entidade.ficha : this.entidadeForm.get('ficha').value"
  [login]="login" [data]="this.entidade.data_rcms ? this.entidade.data_rcms : this.entidadeForm.get('data_rcms').value"
  [(visualizar)]="visualizarFicha">
</app-saldo-ficha-dlg>
<app-exclusao-rcms-dlg [(visualizar)]="visualizarExclusao" [rcms]="entidade" [login]="login"></app-exclusao-rcms-dlg>


<p-dialog header="Atenção" [(visible)]="display" [style]="{width: '50vw'}">
  <span>Usuário: {{login.usuario.nome}}, não foi relacionado para movimentação no estoque em seu perfil. Entre em
    contato com o administrador do sistema.</span>
  <br>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="redirecionar()" label="Ok" styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>